import { personalizedResource } from '@/lib/resources/personalized-resource';

// types
import type { ShowDetails, ShowRowContent } from '@/lib/types/api/show-data'

export const myListShows = personalizedResource<ShowRowContent | ShowDetails>({
  key: 'myListShows',
  endpoint: '/api/profile/my-list-shows/',
  select: (json) => (json as { myListShowsData: (ShowRowContent | ShowDetails)[] | null }).myListShowsData,
})
